export default {
  miningPickaxeCrafting: 'Spitzhacken-Herstellung',
  miningDepthDweller: 'Tiefengräber',
  miningSmeltery: 'Hochofen',
  miningEnhancement: 'Aufwertungen',
  miningResin: 'Harz',
  miningSmoke: 'Rauch',
  miningCompressAluminium: 'Aluminium komprimieren',
  miningCompressCopper: 'Kupfer komprimieren',
  miningCompressTin: 'Zinn komprimieren',
  miningCompressIron: 'Eisen komprimieren',
  miningCompressTitanium: 'Titan komprimieren',
  miningCompressPlatinum: 'Platin komprimieren',
  miningCompressIridium: 'Iridium komprimieren',
  miningCompressOsmium: 'Osmium komprimieren',
  miningCompressLead: 'Blei komprimieren',
  villageBuildings1: 'Stufe-1-Gebäude',
  villageBuildings2: 'Stufe-2-Gebäude',
  villageBuildings3: 'Stufe-3-Gebäude',
  villageBuildings4: 'Stufe-4-Gebäude',
  villageBuildings5: 'Stufe-5-Gebäude',
  villageBuildings6: 'Stufe-6-Gebäude',
  villageBuildings7: 'Stufe-7-Gebäude',
  villageCoinUpgrades: 'Goldmünzen-Verbesserungen',
  villageUpgradeScythe: 'Sense-Verbesserung',
  villageUpgradeHatchet: 'Beil-Verbesserung',
  villageUpgradePickaxe: 'Spitzhacke-Verbesserung',
  villageUpgradeWateringCan: 'Gießkanne-Verbesserung',
  villageUpgradeInvestment: 'Investition-Verbesserung',
  villageUpgradeBasics: 'Grundlagen-Verbesserung',
  villageUpgradeProcessing: 'Verarbeitung-Verbesserung',
  villageUpgradePump: 'Pumpwerk-Verbesserung',
  villageUpgradeSand: 'Sand-Verbesserung',
  villageUpgradeBook: 'Buch-Verbesserung',
  villageUpgradeAxe: 'Axt-Verbesserung',
  villageUpgradeBomb: 'Bombe-Verbesserung',
  villageUpgradeToll: 'Zoll-Verbesserung',
  villageUpgradeFishingRod: 'Angel-Verbesserung',
  villageUpgradeHolyBook: 'Heiliges-Buch-Verbesserung',
  villageUpgradeBreakthrough: 'Durchbruch-Verbesserung',
  villageUpgradeModifiedPlants: 'Modifizierte-Pflanzen-Verbesserung',
  villageUpgradeDopamine: 'Dopamin-Verbesserung',
  villageUpgradeAdrenaline: 'Adrenalin-Verbesserung',
  villageUpgradeSprinkler: 'Rasensprenger-Verbesserung',
  villageUpgradeGreed: 'Gier-Verbesserung',
  villageUpgradeAmbition: 'Ambition-Verbesserung',
  villageUpgradeUnderstanding: 'Verständnis-Verbesserung',
  villageUpgradeCuriosity: 'Neugier-Verbesserung',
  villageUpgradeWorship: 'Verehrung-Verbesserung',
  villageUpgradeBartering: 'Feilschen-Verbesserung',
  villageUpgradeSparks: 'Funken-Verbesserung',
  villageOffering1: 'Opfergaben',
  villageOffering2: 'Stufe-2-Opfergaben',
  villageOffering3: 'Stufe-3-Opfergaben',
  villageOffering4: 'Stufe-4-Opfergaben',
  villageSpecialIngredient: 'Besondere Zutaten',
  hordeCorruptedFlesh: 'Erbeute korruptes Fleisch',
  hordeSacrifice: 'Opfer',
  hordeChessEquipment: 'Schach-Ausrüstung',
  hordeUpgradeRoyalArmor: 'Königliche-Rüstung-Verbesserung',
  hordeUpgradeRoyalStorage: 'Königliches-Lager-Verbesserung',
  hordeUpgradeRoyalButcher: 'Königlicher-Schlachter-Verbesserung',
  hordeUpgradeRoyalCrypt: 'Königliches-Grab-Verbesserung',
  hordeUpgradeRoyalSecret: 'Königliches-Geheimnis-Verbesserung',
  hordeUpgradeRoyalBlessing: 'Königlicher-Segen-Verbesserung',
  hordeEquipmentBlessedSword: 'Gesegnetes-Schwert-Ausrüstung',
  hordeEquipmentBlessedArmor: 'Gesegnete-Rüstung-Ausrüstung',
  hordeEquipmentBlessedBow: 'Gesegneter-Bogen-Ausrüstung',
  hordeEquipmentBlessedFlame: 'Gesegnete-Flamme-Ausrüstung',
  hordeEquipmentBlessedWater: 'Gesegnetes-Wasser-Ausrüstung',
  hordeEquipmentBlessedShield: 'Gesegneter-Schild-Ausrüstung',
  hordeClassArcher: 'Bogenschützen-Klasse',
  hordeClassMage: 'Magier-Klasse',
  hordeClassKnight: 'Ritter-Klasse',
  hordeClassAssassin: 'Assassine-Klasse',
  hordeClassShaman: 'Schamane-Klasse',
  hordeClassPirate: 'Pirat-Klasse',
  hordeClassUndead: 'Untoter-Klasse',
  hordeClassCultist: 'Kultist-Klasse',
  hordeClassScholar: 'Gelehrter-Klasse',
  hordeAreaMonkeyJungle: 'Affendschungel',
  hordeAreaLoveIsland: 'Liebesinsel',
  hordeMonsterToothWarzone: 'Monsterzähne (Kriegsgebiet)',
  hordeMonsterToothMonkeyJungle: 'Monsterzähne (Affendschungel)',
  hordeMonsterToothLoveIsland: 'Monsterzähne (Liebesinsel)',
  farmDisableEarlyGame: 'Deaktiviere "Erste Pflanzen"',
  farmCare: 'Pflege',
  farmCropExp: 'Pflanzenerfahrung',
  farmFertilizer: 'Dünger',
  galleryConversion: 'Umwandlung',
  galleryInspiration: 'Inspiration',
  galleryAuction: 'Auktionen',
  galleryDrums: 'Farbtrommeln',
  galleryShape: 'Formen',
  galleryCanvas: 'Leinwand',
  gemDiamond: 'Diamantgenerator',
  schoolLibrarySubfeature: 'Bücherei',
  relicMuseum: 'Museum',
  cardShiny: 'Glitzerkarten',
  treasureDual: 'Doppelte Schätze',
  treasurePrestigious: 'Prestigereiche Schätze',
  bloomPoppyFlower: 'Mohn',
  bloomIrisFlower: 'Schwertlilie',
  bloomLilyFlower: 'Lilie',
  bloomOrchidFlower: 'Orchidee',
  bloomCornflowerFlower: 'Kornblume',
  summerFestivalTerraform: 'Terraforming'
};
